import { UploadedFile } from "../../interfaces/uploaded-file.interface";
import { getFileExtension } from "../fileTypes";


export const capitalizeFirstLetter = (text: string) => {
    const lowerText = text.toLowerCase();
    return lowerText.replace(/(^\¿?\s*[a-záéíóúüñ])/i, (match) => match.toUpperCase());
};

export const renameFile = (
    file: UploadedFile,
    numeroPredenuncia: string,
    index?: number
): string => {
    const extension = getFileExtension(file.mediaType);

    // No agregar índice al archivo Denuncia
    if (file.documentType.value === "Denuncia") {
        return `${file.documentType.value}_${numeroPredenuncia}${extension}`;
    }

    return `${file.documentType.value}_${numeroPredenuncia}_${index}${extension}`;
};

export const removeAccents = (text: string): string => {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

/**
 * 
 * @param s NORMALIZA (QUITA TILDES) Y CONVIERTE A MINUSCULA
 * @returns 
 */
export const normalizeText = (s?: string) =>
    (s ?? "")
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();